import React, { Component } from 'react';
import * as THREE from 'three';
import ReactDOM from 'react-dom';
import { Grid } from 'semantic-ui-react';
import ForgeViewer from './forgeViewer';
import ModelProgress from './modelProgress';
import { connect } from "react-redux";

class DualForgeViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            urn1: "",
            urn2: "",
            firstViewerStarted: false,
            secondViewerStarted: false,
            shouldStartSecondViewer: false,
            showStatistics: false,
            renderFirstViewer: false,
            renderRightSection: undefined,
        };
        this.child1 = null
        this.child2 = null

        this.Autodesk = null;

        this.cameraChangeOnInterval = null

        this.viewer1CameraChangeMutex = undefined;
        this.viewer2CameraChangeMutex = undefined;
    }

    increaseViewCounter(uid) {
        let sendData = {
            "action": "increase-project-counters",
            "data": {
                "UID": uid,
                "CounterType": "ViewCount"
            }
        }

        this.props.webSocketClient.run(sendData);
    }

    onReceiveGeomInfo(data) {
        document.title = data.data.DisplayName + " | Autonomous mesh segmentation"
        window.gtag('config', 'UA-138495762-1', { 'page_path': window.location.pathname + window.location.search });
        // console.log('DATA: ', data.data.DisplayName)
    }

    getGeomInfo(uid) {
        let sendData = {
            "action": "get-geom-info",
            "data": {
                "UID": uid
            }
        }

        this.props.webSocketClient.run(sendData, this.onReceiveGeomInfo.bind(this));
    }

    componentWillUnmount() {
        document.title = "Autonomous mesh segmentation | CCTech Research Project"
        // console.log("!!!!!!!!! dual Forge Viewer will unmount !!!!!!!!!!!")

        this.Autodesk = null;

        this.child1 = null
        this.child2 = null
        this.cameraChangeOnInterval = null

        this.viewer1CameraChangeMutex = undefined;
        this.viewer2CameraChangeMutex = undefined;

        this.setState({
            urn1: "",
            urn2: "",
            firstViewerStarted: false,
            secondViewerStarted: false,
            shouldStartSecondViewer: false,
            showStatistics: false
        })
    }

    componentDidMount() {
        this.Autodesk = Window.AutodeskObject;
        let uid = this.props.geomId;
        this.increaseViewCounter(uid);
        this.getGeomInfo(uid);

        if (!this.props.parentState.isSharedLink) {
            this.setState({ renderRightSection: 'modelProgress' })
        }
        else {
            // console.log("Entering demo viewer mode.")
            this.setState({
                urn1: btoa(`urn:adsk.objects:os.object:${process.env.REACT_APP_ADSK_BUCKET}/ml-mesh-seg_${uid}_input.zip`),
                urn2: btoa(`urn:adsk.objects:os.object:${process.env.REACT_APP_ADSK_BUCKET}/ml-mesh-seg_${uid}_output.zip`)
            }, () => {
                this.startFirstViewer(null)
            });
        }

        this.props.updateParentState()
    }

    whatsNext() {
        this.setState({
            firstViewerStarted: true
        })

        let startFlag = (this.state.shouldStartSecondViewer && (!this.state.secondViewerStarted)) || this.props.parentState.isSharedLink
        if (startFlag) {
            this.renderSecondViewer()
        }
    }

    readyForSecondViewer(response) {
        this.setState({
            shouldStartSecondViewer: true,
            urn2: response.urn
        })

        if (this.state.firstViewerStarted && (!this.state.secondViewerStarted)) {
            this.renderSecondViewer()
        }
    }

    startFirstViewer(response) {
        if (!this.props.parentState.isSharedLink) {
            // console.log("creating your own segmentation !!!")
            this.setState({
                urn1: response.urn
            }, () => {
                this.renderFirstViewer()
            })
        }
        else {
            this.renderFirstViewer()
        }
    }

    renderFirstViewer() {
        this.setState({
            renderFirstViewer: true
        })
        const intervalId = setInterval(() => {
            if (this.child1 && this.child1.viewer) {
                this.props.OnFirstViewerLoaded(this.child1.viewer)
                clearInterval(intervalId)
            }
        }, 100);
    }

    renderSecondViewer() {
        this.setState({
            secondViewerStarted: true,
            renderRightSection: 'secondViewer'
        })
        // console.log("renderSecondViewer function called !!!", this.props.uploadData)
        this.props.OnDualViewerLoaded(this.props.geomId)
    }

    getChildRef1(ref) {
        // console.log('child 1 ref is : ', ref)
        this.child1 = ref
    }

    getChildRef2(ref) {
        // console.log('child 2 ref is : ', ref)
        this.child2 = ref

        this.child1.viewer.restoreState(this.child2.viewer.getState());

        this.child1.viewer.addEventListener(this.Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
            if (!this.viewer2CameraChangeMutex) {
                clearTimeout(this.viewer1CameraChangeMutex);
                // this.child2.viewer.restoreState(this.child1.viewer.getState());

                let cam1 = this.child1.viewer.navigation.getCamera();

                let pos = new THREE.Vector3(cam1.position.x, cam1.position.y, cam1.position.z);
                let target = new THREE.Vector3(cam1.target.x, cam1.target.y, cam1.target.z);
                let upVector = new THREE.Vector3(cam1.up.x, cam1.up.y, cam1.up.z);

                this.child2.viewer.navigation.setView(pos, target);
                this.child2.viewer.navigation.setCameraUpVector(upVector);
                // this.child2.viewer.navigation.setFocalLength(cam1.far);
                this.child2.viewer.navigation.setVerticalFov(cam1.fov);

                this.viewer1CameraChangeMutex = setTimeout(() => { this.viewer1CameraChangeMutex = undefined }, 1000)
            }
        });

        this.child2.viewer.addEventListener(this.Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
            if (!this.viewer1CameraChangeMutex) {
                clearTimeout(this.viewer2CameraChangeMutex);
                // this.child1.viewer.restoreState(this.child2.viewer.getState());

                let cam1 = this.child2.viewer.navigation.getCamera();

                let pos = new THREE.Vector3(cam1.position.x, cam1.position.y, cam1.position.z);
                let target = new THREE.Vector3(cam1.target.x, cam1.target.y, cam1.target.z);
                let upVector = new THREE.Vector3(cam1.up.x, cam1.up.y, cam1.up.z);

                this.child1.viewer.navigation.setView(pos, target);
                this.child1.viewer.navigation.setCameraUpVector(upVector);
                // this.child1.viewer.navigation.setFocalLength(cam1.far);
                this.child1.viewer.navigation.setVerticalFov(cam1.fov);

                this.viewer2CameraChangeMutex = setTimeout(() => { this.viewer2CameraChangeMutex = undefined }, 1000)
            }
        });

        this.child1.viewer.setBackgroundColor(135, 206, 235, 255, 255, 255)
        this.child2.viewer.setBackgroundColor(255, 255, 255, 255, 255, 255)
    }

    getViewerUIHeights() {
        const containerHeight = this.props.app.windowSize.height-80
        let viewerHeight = containerHeight
        if (this.props.app.windowSize.width <= 991) {
            viewerHeight /= 2
        }
        return {
            containerHeight: containerHeight,
            viewerHeight: viewerHeight
        }
    }

    renderRightSection() {
        switch (this.state.renderRightSection) {
            case 'modelProgress':
                return (
                    <ModelProgress webSocketClient={this.props.webSocketClient}
                        parentState={this.props.parentState}
                        geomId={this.props.geomId}
                        startFirstViewer={this.startFirstViewer.bind(this)}
                        readyForSecondViewer={this.readyForSecondViewer.bind(this)} />
                )    
            case 'secondViewer':
                return (
                    <ForgeViewer
                        updateCameraEvent={function (event) { this.cameraEvent = event }.bind(this)}
                        viewerIndex={1}
                        onRef={this.getChildRef2.bind(this)}
                        urn={this.state.urn2}
                        Autodesk={this.Autodesk}
                        whatsNext={() => { }}
                        appState={this.props.app} />
                )
            default:
                return '';
        }
    }

    render() {

        const rightSection = this.renderRightSection();
        const viewerElementHeights = this.getViewerUIHeights()

        return (
            <Grid columns={2} style={{height: viewerElementHeights.containerHeight}}>
                <Grid.Column
                    style={{height: viewerElementHeights.viewerHeight}}
                    mobile={16}
                    tablet={16}
                    computer={8}
                    width={8}
                >
                    {this.state.renderFirstViewer ? (
                        <ForgeViewer
                            updateCameraEvent={function (event) { this.cameraEvent = event }.bind(this)}
                            viewerIndex={0}
                            onRef={this.getChildRef1.bind(this)}
                            urn={this.state.urn1}
                            Autodesk={this.Autodesk}
                            whatsNext={this.whatsNext.bind(this)}
                            appState={this.props.app} />
                    ) : ''}
                </Grid.Column>
                <Grid.Column
                    style={{height: viewerElementHeights.viewerHeight}}
                    mobile={16}
                    tablet={16}
                    computer={8}
                    width={8}
                    styles={{ background: '#FFFFFF' }}
                >
                    {rightSection}
                </Grid.Column>
            </Grid>
        );
    }
}

const mapStateToProps = ({ app }) => ({
    app,
});

export default connect(mapStateToProps)(DualForgeViewer);